<template>
	<sf-data-table
		ref="repayMstTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="repayMstCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		height="51vh"
		fit="fit"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@changedRow="changedRow"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import utils from '@/utils';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.gridList;
		},
		repayMstCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001296'), //전표구분
					prop: 'slipScnNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001225'), // 클레임no
					headerAlign: 'center',
					prop: 'clmNo',
					width: '150px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001056'), // C/TYPE
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), // 품번
					prop: 'causPartNo',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'causPartNm',
					headerAlign: 'center',
					width: '330px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001341'), // 협력사
					prop: 'aplCpnyNm',
					headerAlign: 'center',
					width: '80px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001924'), // 실납품사
					prop: 'dlvgNm',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001174'), // R/O 확정일
					prop: 'roAplcDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002039'), //변제신청일
					prop: 'aplcDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002032'), //변제확정일
					prop: 'dcsnDd',
					width: '120px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC001295'), //변제금액
					prop: 'aplRpymAmt',
					width: '120px',
					headerAlign: 'center',
					align: 'right'
				},
				{ label: '', minWidth: '10px', sortable: false }
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		changedRow({ rows, changedRow }) {
			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';
			let startDcsnDdBe = this.$moment(this.searchParams.startDcsnDd).subtract('1', 'M').format('YYYYMM');
			let endDcsnDdBe = this.$moment(this.searchParams.endDcsnDd).subtract('1', 'M').format('YYYYMM');
			let startDcsnDd = this.$moment(this.searchParams.startDcsnDd).format('YYYYMM');
			let endDcsnDd = this.$moment(this.searchParams.endDcsnDd).format('YYYYMM');
			if (
				this.searchParams.dlrCpnyNm !== undefined ||
				this.searchParams.slipScn !== undefined ||
				this.searchParams.startDcsnDd !== undefined ||
				this.searchParams.causPartNo !== undefined ||
				this.searchParams.endDcsnDd !== undefined ||
				this.searchParams.clmDd02 !== undefined ||
				this.searchParams.ctype !== undefined
			) {
				queryStr = objectToQuerystring({
					dlrCpnyNm: this.searchParams.dlrCpnyNm, //실납품사
					slipScn: this.searchParams.slipScn, //전표구분
					ctype: this.searchParams.ctype, //ctype
					clmDd02: this.searchParams.clmDd02, //날짜구분값(10.변제확정일 20. R/O확정일)
					causPartNo: this.searchParams.causPartNo, //품번
					startDcsnDd: startDcsnDd, //확정일자from
					endDcsnDd: endDcsnDd, //확정일자to
					startDcsnDdBe: startDcsnDdBe, //확정일자 전달from
					endDcsnDdBe: endDcsnDdBe //확정일자 전달to
				});
			}

			const url = `${BASE_URL}/mqy/qlty/repayMst/v1/repayMsts/excel` + queryStr;

			const params = { url, columns: this.repayMstCols };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
